// src/Pages/Landing/TrubaduuriLanding.jsx
import React from "react";
import NeonButton from "../../components/ResponsiveButton/NeonButton.jsx";
import PriceInfoBox from "../../components/PriceInfoBox/PriceInfoBox.jsx";
import { trackLandingCta } from "../../utils/analytics";

/**
 * Trubaduuri-landing React Shell -sivulle.
 * Metat ja JSON-LD tulevat WP:stä; tässä vain näkyvä sisältö.
 */

export default function TrubaduuriLanding() {
  return (
    <section className="relative max-w-6xl mx-auto px-4 pt-24 pb-24">
      {/* Hero */}
      <header className="rounded-2xl overflow-hidden ring-1 ring-black/10 dark:ring-white/10 bg-white/70 dark:bg-black/50 backdrop-blur-md p-8 md:p-12 shadow-lg">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight text-black dark:text-white">
          Trubaduuri juhliin – koko Suomi
        </h1>

        <p className="mt-3 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
          Buukkerista löydät vapaat trubaduurit{" "}
          <strong>reaaliaikaisesti</strong> ja saat{" "}
          <strong>tarjouksen</strong> heti sähköpostiisi. Kokonaishinta
          vahvistuu tarjouksessa (sis. myös matkakulut).
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <a
            href="https://buukkeri.fi/?type=trubaduuri&clear=1#tulokset"
            aria-label="Katso vapaat trubaduurit"
            onClick={() =>
              trackLandingCta({
                actType: "trubaduuri",
                region: "koko-suomi",
                placement: "hero_primary_all",
              })
            }
          >
            <NeonButton variant="primary" size="md" className="font-semibold">
              Katso vapaat trubaduurit
            </NeonButton>
          </a>

          <a
            href="https://buukkeri.fi/?type=trubaduuri&book=1&clear=1"
            aria-label="Avaa pikahaku"
            onClick={() =>
              trackLandingCta({
                actType: "trubaduuri",
                region: "koko-suomi",
                placement: "hero_quick_search",
              })
            }
          >
            <NeonButton variant="secondary" size="md" className="font-semibold">
              Avaa pikahaku
            </NeonButton>
          </a>
        </div>
      </header>

      {/* Hintainfoboksi: trubaduurien valtakunnallinen keskihinta */}
      <div className="mt-8">
        <PriceInfoBox
          title="Trubaduurien keskihinnat Suomessa – suosituimmat setit"
          types={["trubaduuri"]}
          autoTopSets
          topN={3}
          regionId={null}            // null = näytä koko Suomen keskiarvo
          refreshMs={15 * 60 * 1000} // päivitys 15 min välein
          compact={true}
          nationalLabel="Buukkerin keskihinta"
        />
        <p className="mt-2 text-black/80 dark:text-white/80 text-sm opacity-70">
          Hinta on suuntaa-antava keskiarvo koko Suomesta.{" "}
          <strong>Lopullinen hinta täsmentyy tarjouspyynnössä</strong> ja se
          sisältää myös matkakulut. Hinnat perustuvat Buukkerin trubaduurien
          hinnastoihin eri puolilla Suomea – ei yksittäiseen keikkaan tai
          yksittäisen kaupungin nimeen.
        </p>
      </div>

      {/* Miten buukkeri toimii? */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <h2 className="text-2xl md:text-3xl font-semibold text-black dark:text-white mb-3">
          Miten buukkeri toimii?
        </h2>

        <ul className="list-disc pl-5 space-y-1 text-black/80 dark:text-white/80 text-base md:text-lg">
          <li>Valitse päivämäärä → näet vapaat trubaduurit.</li>
          <li>
            Lähetä tarjouspyyntö → saat kokonaishinnan ja ohjeet sähköpostiin.
          </li>
          <li>Hyväksy linkistä → maksa varausmaksu → varaus vahvistuu.</li>
          <li>Keikan jälkeen saat palautelinkin ja koodin arviota varten.</li>
        </ul>
      </div>

      {/* Mitä profiilista löytyy? */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <h2 className="text-2xl md:text-3xl font-semibold text-black dark:text-white mb-3">
          Mitä esiintyjän profiilista löytyy?
        </h2>

        <p className="text-black/80 dark:text-white/80 text-base md:text-lg">
          Videot, audiot, kuvagalleria, kuvaus, soittimet, lisäpalvelut,
          keikkailualueet ja setit sekä dynaaminen kalenteri.
        </p>
      </div>
    </section>
  );
}
